module.exports = __webpack_public_path__ + "static/media/Engadin_Tipp_2.9bcb3c8a.jpg";